interface AllTypeCategoryI {
  name: string;
  displayName: string;
}

const AllTypeCategory: AllTypeCategoryI = {
  name: "all-types",
  displayName: "Sve kategorije"
};

export default AllTypeCategory;



// WEBPACK FOOTER //
// ./src/models/allTypeCategory.ts